<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="ded"></a><span>To Dade County, Florida, and to all those who were touched by the tremendous force of Andrew, and especially to Stuart and Teresa Davant and their son, Charlie, who survived the storm in a closet.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4d2c9d89